$(function() {
    $(document).ready(function() {
        if ($('.location-contacts')[0]) {
            const tab = $('.location-contacts__tabHeading h3');

            $(tab).click(function() {
                $(this)
                    .parent()
                    .next('.location-contacts__countries')
                    .slideToggle();
            });

            var country = $('.location-contacts__countries span, .location-contacts__marker');
            var contactCta = $('.location-contacts__countryContactsItem .button');
            const title = $('.location-contacts__contactListTitle');

            $(country).click(function() {
                const dataCat = $(this).attr('data-category');
                $(country)
                    .not(this)
                    .removeClass('active');
                $(this).toggleClass('active');

                $(title).addClass('show-title');

                const matchingMarker = $('.location-contacts__marker[data-category="' + dataCat + '"]');
                const nonMatchingMarker = $('.location-contacts__marker').not('[data-category="' + dataCat + '"]');

                nonMatchingMarker.removeClass('active');

                if (matchingMarker.length > 0) {
                    matchingMarker.addClass('active');
                }

                const matchingContacts = $('.location-contacts__countryContacts[data-category="' + dataCat + '"]');
                const nonMatchingContacts = $('.location-contacts__countryContacts').not(
                    '[data-category="' + dataCat + '"]'
                );

                nonMatchingContacts.fadeOut(400);

                if (matchingContacts.length > 0) {
                    matchingContacts.delay(400).fadeIn(400);
                }

                $('html, body').animate(
                    {
                        scrollTop: $('.location-contacts__contactList').offset().top - 120,
                    },
                    1000
                );
            });

            $(contactCta).click(function(event) {
                event.preventDefault();
                var targetHash = $(this)
                    .attr('href')
                    .substring(1);
                $('html, body').animate(
                    {
                        scrollTop: $('.contact__container').offset().top - 120,
                    },
                    1000
                );

                $('#input_1_8 option')
                    .filter(function() {
                        return $(this).val() === targetHash;
                    })
                    .prop('selected', true);

                $('#input_1_8 option').change();
            });
        }
    });
});
